export const APP_HEADER = 'BHP';
export const APP_SUB_HEADER = 'Resource and Reserve Reporting';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DROPDOWN_LANGUAGE = 4;
export const DROPDOWN_FLUENCY = 5;
export const DROPDOWN_ROLETYPE = 2;
export const DROPDOWN_ACCESS_LEVEL = 33;
export const DROPDOWN_ROLETYPE_CP_QP_ID = '2.2';
export const DROPDOWN_PROFESSIONAL_BODY = 7;
export const DROPDOWN_MEMBERSHIP_CATERGORY = 8;
export const DROPDOWN_USERTYPE = 6;
export const DROPDOWN_GENDER = 3;
export const DROPDOWN_FILETYPE = 9;
export const DROPDOWN_REPORTING_CYCLE_YEAR = 12;
export const DROPDOWN_DATA_CAPTURE_TABS = 21;
export const DROPDOWN_DATA_CAPTURE_TABS_ASX_RESOURCE = 25;
export const DROPDOWN_DATA_CAPTURE_TABS_ASX_RESERVE = 21;
export const DROPDOWN_DATA_CAPTURE_TABS_US_SEC_RESOURCE = 27;
export const DROPDOWN_DATA_CAPTURE_TABS_US_SEC_RESERVE = 26;
export const DROPDOWN_REPORTS = 30;
export const DROPDOWN_WORKFLOWS = 31;
export const ADMINISTRATION_ROLE = 'administrator';
export const CP_QP_ROLE = 'workflowuser-cp/qp';
export const ORC_ROLE = 'workflowuser-cp/qp/orc';
export const CP_QP_ORC_ROLE = 'workflowuser-orc';
export const ENDORSER_ROLE = 'workflowuser-endorser';
export const ENDUSER_ROLE = 'workflowuser-enduser';
export const CONSUMER_ROLE = 'worklfowuser-consumer';
export const ACTIVE = 'Active';
export const IN_ACTIVE = 'In-Active';
export const NAME = 'Name';
export const LOGIN = 'Login';
export const STATUS = 'Status';
export const ROLE_TYPE = 'Role type';
export const ACCESS_LEVEL = 'Access level';
export const UPDATED_ON = 'Updated on';
export const USER_PROFILE = 'user profile';
export const USER_PROFILE_URL = 'user-profile';
export const TRAINING = 'training';
export const AFFILIATION = 'affiliation';
export const UPLOADS = 'uploads';
export const NOTIFICATION_SUCCESS = 'success';
export const NOTIFICATION_WARNING = 'warning';
export const NOTIFICATION_ERROR = 'danger';
export const MANAGE_USERS_URL = 'manage-users';
export const USER_ID_URL = 'user:id';
export const MANAGE_USER_PROFILE_URL = `${MANAGE_USERS_URL}/user`;
export const NEW_USER_URL = 'new';
export const MANAGE_ASSESTS_URL = 'manage-assets';
export const DASHBOARD_URL = 'dashboard';
export const PAGE_NOT_FOUND_URL = 'page-not-found';
export const UN_AUTHORIZED_URL = '401';
export const FULL_PATH = 'full';
export const ADMINISTRATION_KEY = 'ADMINISTRATION';
export const ADMINISTRATION = 'administration';
export const SETUP_PREPERATION_KEY = 'SETUP_PREPERATION';
export const SETUP_PREPERATION = 'Setup & Preparation';
export const MANAGE_USERS_KEY = 'MANAGE_USERS';
export const MANAGE_USERS = 'manage users';
export const MANAGE_ASSETS_KEY = 'MANAGE_ASSETS';
export const MANAGE_ASSETS = 'manage assets';
export const MANAGE_CONFIGURATION_KEY = 'MANAGE_CONFIGURATIONS';
export const MANAGE_CONFIGURATION = 'manage configurations';
export const MANAGE_CONFIGURATION_URL = 'manage-configurations';
export const MANAGE_DOCUMENTS_KEY = 'MANAGE_DOCUMENTS';
export const MANAGE_DOCUMENTS = 'Document Storage';
export const MANAGE_DOCUMENTS_URL = 'manage-documents';
export const MANAGE_DOCUMENTS_REGULATORY_CORRESPONDENCE_URL =
  'regulatory_correspondence';
export const MANAGE_DOCUMENTS_REGULATORY_CORRESPONDENCE =
  'Regulatory Correspondence';
export const MANAGE_DOCUMENTS_EXPLORATION_AND_POTENTIAL_URL =
  'exploration_and_potential';
export const MANAGE_DOCUMENTS_EXPLORATION_AND_POTENTIAL =
  'Exploration and Potential Mineralisation';
export const MANAGE_REPORTING_LIFECYCLE_KEY = 'MANAGE_REPORTING_LIFECYCLE';
export const MANAGE_REPORTING_LIFECYCLE_URL = 'manage-reporting-cycle';
export const MANAGE_REPORTING_LIFECYCLE = 'manage reporting cycle';
export const CREATE_REPORTING_CYCLE = 'create-reporting-cycle';
export const VIEW_REPORTING_CYCLE = 'view-reporting-cycle';
export const UPDATE_DROPDOWNS = `update-dropdowns`;
export const VIEW_REPORTING_CYCLE_URL = `${MANAGE_REPORTING_LIFECYCLE_URL}/${VIEW_REPORTING_CYCLE}`;
export const CREATE_REPORTING_LIFECYCLE_URL = `${MANAGE_REPORTING_LIFECYCLE_URL}/${CREATE_REPORTING_CYCLE}`;
export const MANAGE_WORKFLOWS_KEY = 'MANAGE_WORKFLOWS';
export const MANAGE_WORKFLOWS = 'manage workflows';
export const MANAGE_WORKFLOWS_URL = 'manage-workflows';
export const MANAGE_DASHBOARD = 'manage dashboard';
export const WORKFLOWS_DASHBOARD_URL = 'manage-dashboard';
export const ANNUAL_REPORTING_URL = 'reporting-workflows';
export const PRINTER_PROOF = 'printer-proof';
export const PRINTER_PROOF_ACTION_URL = `${PRINTER_PROOF}`;
export const CONSENT_ON_BEHALF_URL = 'consent_on_behalf';
export const CONSENT_ON_BEHALF = 'Consent on Behalf';
export const CP_QP_REPORT = 'cp-qp-report';
export const CP_QP_REPORT_ACTION_URL = `${CP_QP_REPORT}`;
export const ANNUAL_REPORTING = 'Annual Reporting';
export const CP_QP_NOMINATION_URL = 'cp-qp-nomination';
export const CP_NOMINATION = 'cp-nomination';
export const CONSENT_TO_PUBLISH = 'consent-to-publish';
export const IN_PROGRESS_URL = 'in-progress';
export const IN_REVIEW_URL = 'in-review';
export const COMPLETE_URL = 'complete';
export const CP_QP_NOMINATION = 'CP/QP Nomination';
export const ADMIN_CP_QP_NOMINATION_KEY = 'ADMIN_CP_QP_NOMINATION';
export const CP_QP_NOMINATIONS = 'CP/QP Nominations';
export const REPORTING_WORKFLOWS = 'Data Entry and Consent Workflows';
export const REPORTING_WORKFLOWS_URL = 'reporting-workflow';
export const DATA_CAPTURE = 'data-capture';
export const DATA_CAPTURE_ENDORSEMENT_URL = 'data-capture-endorsement';
export const ADMIN_CP_QP_NOMINATION_URL = `${MANAGE_WORKFLOWS_URL}/${CP_QP_NOMINATION_URL}`;
export const ADMIN_CP_QP_NOMINATION_DASHBOARD_URL = `${WORKFLOWS_DASHBOARD_URL}/${CP_QP_NOMINATION_URL}`;
export const ADMIN_ANNUAL_REPORTING_DASHBOARD_URL = `${WORKFLOWS_DASHBOARD_URL}/${REPORTING_WORKFLOWS_URL}`;
export const ADMIN_REPORTING_WORKFLOW_KEY =
  'MANAGE_WORKFLOWS_REPORTING_WORKFLOW';
export const ADMIN_REPORTING_WORKFLOW_URL = `${MANAGE_WORKFLOWS_URL}/${ANNUAL_REPORTING_URL}`;
export const CP_QP_MANAGE_WORKFLOWS_URL = 'cp-qp-manage-workflows';
export const CP_QP_WORKFLOWS_DASHBOARD_URL = 'cp-qp-manage-dashboard';
export const CP_QP_CP_QP_NOMINATION_KEY = 'CP_QP_CP_QP_NOMINATION';
export const CP_QP_CP_QP_NOMINATION_URL = `${CP_QP_MANAGE_WORKFLOWS_URL}/${CP_QP_NOMINATION_URL}`;
export const CP_QP_CP_QP_NOMINATION_DASHBOARD_URL = `${CP_QP_WORKFLOWS_DASHBOARD_URL}/${CP_QP_NOMINATION_URL}`;
export const CP_QP_REPORTING_WORKFLOW_KEY =
  'CP_QP_REPORTING_WORKFLOW_REPORTING_WORKFLOW';
export const CP_QP_REPORTING_WORKFLOW_URL = `${CP_QP_MANAGE_WORKFLOWS_URL}/${REPORTING_WORKFLOWS_URL}`;
export const CP_QP_ORC_MANAGE_WORKFLOWS_URL = 'cp-qp-orc-manage-workflows';
export const CP_QP_ORC_CP_QP_NOMINATION_KEY = 'CP_QP_ORC_CP_QP_NOMINATION';
export const CP_QP_ORC_CP_QP_NOMINATION_URL = `${CP_QP_ORC_MANAGE_WORKFLOWS_URL}/${CP_QP_NOMINATION_URL}`;
export const CP_QP_ORC_REPORTING_WORKFLOW_KEY =
  'CP_QP_ORC_REPORTING_WORKFLOW_REPORTING_WORKFLOW';
export const CP_QP_ORC_REPORTING_WORKFLOW_URL = `${CP_QP_ORC_MANAGE_WORKFLOWS_URL}/${REPORTING_WORKFLOWS_URL}`;
export const ORC_MANAGE_WORKFLOWS_URL = 'orc-manage-workflows';
export const ORC_CP_QP_NOMINATION_KEY = 'ORC_CP_QP_NOMINATION';
export const ORC_CP_QP_NOMINATION_URL = `${ORC_MANAGE_WORKFLOWS_URL}/${CP_QP_NOMINATION_URL}`;
export const ORC_REPORTING_WORKFLOW_KEY =
  'ORC_REPORTING_WORKFLOW_REPORTING_WORKFLOW';
export const ORC_REPORTING_WORKFLOW_URL = `${ORC_MANAGE_WORKFLOWS_URL}/${REPORTING_WORKFLOWS_URL}`;
export const ENDORSER_MANAGE_WORKFLOWS_URL = 'endorser-manage-workflows';
export const CONSUMER_MANAGE_WORKFLOWS_URL = 'view-manage-workflows';
export const ENDORSER_CP_QP_NOMINATION_KEY = 'ENDORSER_CP_QP_NOMINATION';
export const ENDORSER_CP_QP_NOMINATION_URL = `${ENDORSER_MANAGE_WORKFLOWS_URL}/${CP_QP_NOMINATION_URL}`;
export const ENDORSER_REPORTING_WORKFLOW_KEY =
  'ENDORSER_REPORTING_WORKFLOW_REPORTING_WORKFLOW';
export const ENDORSER_REPORTING_WORKFLOW_URL = `${ENDORSER_MANAGE_WORKFLOWS_URL}/${REPORTING_WORKFLOWS_URL}`;
export const CONSUMER_REPORTING_WORKFLOW_KEY =
  'CONSUMER_REPORTING_WORKFLOW_REPORTING_WORKFLOW';
export const CONSUMER_REPORTING_WORKFLOW_URL = `${CONSUMER_MANAGE_WORKFLOWS_URL}/${REPORTING_WORKFLOWS_URL}`;
export const CONSUMER_CP_QP_NOMINATION_KEY = 'CONSUMER_CP_QP_NOMINATION';
export const CONSUMER_CP_QP_NOMINATION_URL = `${CONSUMER_MANAGE_WORKFLOWS_URL}/${CP_QP_NOMINATION_URL}`;
export const WORKFLOWS_KEY = 'WORKFLOWS';
export const WORKFLOWS = 'workflows';
export const ANNUAL_DECLARATIONS_KEY = 'ANNUAL_DECLARATIONS';
export const ANNUAL_DECLARATIONS = 'Annual Declarations';
export const WORKFLOW_DASHBOARD_KEY = 'WORKFLOW_DASHBOARD';
export const WORKFLOWS_DASHBOARD = 'Progress Tracker';
export const REPORTING_KEY = 'REPORTING';
export const REPORTING = 'reporting';
export const REPORTING_URL = 'reporting';
export const REPORT_EXPORTS_KEY = 'REPORTI_EXPORTS';
export const REPORT_EXPORTS = 'Reporting Exports';
export const REPORT_EXPORTS_URL = 'reporting_export';
export const REPORTING_EXPORTS_REPORTS = 'Reports';
export const REPORTING_EXPORTS_REPORTS_URL = 'reports';
export const REPORTING_EXPORTS_PUBLIC_RELEASE_INFO =
  'Public Release Information';
export const REPORTING_EXPORTS_PUBLIC_RELEASE_INFO_URL = 'public_Release_Info';
export const MANAGE_ARCHIVED_DOCUMENTS_URL = 'archived_documents';
export const MANAGE_ARCHIVED_DOCUMENTS_KEY = 'Archived Documents';
export const LIST_VIEW = 'list view';
export const HIERARCHY_VIEW = 'hierarchy view';
export const ASSIGNED_USERS = 'assigned users';
export const PROPERTIES = 'properties';
export const OPTIONAL = 'Optional';
export const HIERARCHY_REGION = 'Region';
export const HIERARCHY_COMMODITY = 'Commodity';
export const HIERARCHY_ASSET = 'Asset';
export const HIERARCHY_DEPOSIT = 'Deposit';
export const HIERARCHY_AREA = 'Area';
export const HIERARCHY_SUB_AREA = 'Sub-area';
export const HIERARCHY_ORE_TYPE = 'Ore-type';
export const HIERARCHY_COMPONY = 'Company';
export const HIERARCHY_LEVEL_DEPOSIT = 5;
export const CP_QP_ORC_ROLE_TYPE = '2.3';
export const DROPDOWN_COMMODITY_GROUPING = 13;
export const DROPDOWN_DEPOSIT_MINE_STATUS = 20;
export const DROPDOWN_LOCATION = 32;
export const DROPDOWN_TONNAGE = 17;
export const DROPDOWN_ORE_TYPE_GRADE = 19;
export const DROPDOWN_MINING_METHOD = 14;
export const DROPDOWN_PRODUCT = 18;
export const DROPDOWN_UNITS = 17;
export const DROPDOWN_DECIMAL_PLACE = 22;
export const DROPDOWN_TABS = 21;
export const DROPDOWN_RECONCILATION_ORETYPE = 23;
export const DROPDOWN_PRICE_UNITS = 28;
export const OWNER_SHIPNUMBER_LEVEL_ADMIN = '0';
export const OWNER_SHIPNUMBER_LEVEL_5_CP_RESERVE = '1';
export const OWNER_SHIPNUMBER_LEVEL_5_CP_RESOURCE = '2';
export const OWNER_SHIPNUMBER_LEVEL_5_QP_RESERVE = '3';
export const OWNER_SHIPNUMBER_LEVEL_5_QP_RESOURCE = '4';
export const OWNER_SHIPNUMBER_LEVEL_4_RESOURCE_ORC_REVIEWER = '6';
export const OWNER_SHIPNUMBER_LEVEL_4_HEAD_OF_GEOSCIENCE_RESERVE = '7';
export const OWNER_SHIPNUMBER_LEVEL_4_HEAD_OF_GEOSCIENCE_RESOURCE = '8';
export const OWNER_SHIPNUMBER_LEVEL_4_EXTERNAL_RESERVE_ENDORSER = '13';
export const OWNER_SHIPNUMBER_LEVEL_4_EXTERNAL_RESOURCE_ENDORSER = '14';
export const OWNER_SHIPNUMBER_LEVEL_2_VP_PLANNING_TECHNICAL_RESOURCE = '10';
export const OWNER_SHIPNUMBER_LEVEL_1_HEAD_OF_TA_RESOURCE = '12';
export const WORKFLOW_DATA_CAPTURE_GENERAL = 'General';
export const WORKFLOW_DATA_CAPTURE_ASSUMPTIONS = 'Assumptions';
export const GENERAL_URL = 'general';
export const ASSUMPTIONS_URL = 'assumptions';
export const RESERVE_LIFE_URL = 'reserve_life';
export const DEPLETION_PRODUCTION_URL = 'depletion_&_production';
export const DEPLETION_URL = 'yoy_changes';
export const RECONCILATION_URL = 'reconciliation';
export const IN_PROGRESS = 'In Progress';
export const IN_REVIEW = 'In Review';
export const COMPLETE = 'Complete';
export const IN_PENDING = 'Pending';
export const CURRENT_YEAR_URL = 'current_year';
export const CHANGES_URL = 'changes_analysis';
export const REPORT_TABLES_URL = 'report_tables';
export const MINE_PLAN_URL = 'mine_plan';
export const DATA_CAPTURE_ENDORSEMENT = 'Data Entry And Endorsement';
export const SUPPORTING_DOCUMENTATION = 'Report Upload and Consent';
export const SUPPORTING_DOCUMENTATION_URL = 'supporting-document-consent';
export const EXCLUSIVE_RESOURCES_URL = 'exclusive_resources';
export const INCLUSIVE_RESOURCES_URL = 'inclusive_resources';
export const EXCLUSIVE_MINERAL_RESOURCES_URL = 'exclusive_mineral_resources';
export const INCLUSIVE_MINERAL_RESOURCES_URL = 'inclusive_mineral_resources';
export const CASHFLOW_TEST_URL = 'cashflow_test';
export const RESOURCE = 'Resource';
export const RESERVE = 'Reserve';
export const CP_RESOURCE = 'CP Resource';
export const CP_RESERVE = 'CP Reserve';
export const QP_RESOURCE = 'QP Resource';
export const QP_RESERVE = 'QP Reserve';
export const REVIEWER = 'Reviewer';
export const ENDORSER_RESOURCE = 'Endorser Resource';
export const ENDORSER_RESERVE = 'Endorser Reserve';
export const EXTERNAL_ENDORSER_RESOURCE = 'External Endorser Resource';
export const EXTERNAL_ENDORSER_RESERVE = 'External Endorser Reserve';
export const ASX_DATA_CAPTURE_REPORTING_CODE = '1';
export const US_SEC_DATA_CAPTURE_REPORTING_CODE = '2';
export const ENDORSER_NEW_CP_QP_AND_ACK =
  'Endorser New CP/QPs and Acknowledgement';
export const ENDORSER_RESOURCES_AND_RESERVES =
  'Endorser Reserves and Resources';
export const WORKFLOW_LAST_UPDATE_BY = 'WORKFLOW_LAST_UPDATE_BY';
export const WORKFLOW_LAST_UPDATE_ON = 'WORKFLOW_LAST_UPDATE_ON';
export const ASX_UPLOAD_AND_CONSENT = 'ASX Report Upload and Consent';
export const US_SEC_UPLOAD_AND_CONSENT = 'US SEC Report Upload and Consent';

export const ADMIN_PROGRESS_TRACKER_TOOLTIP =
  'Click here to view Progress of Data Entry, Consent and CP/QP Nomination Workflows per Region';
export const ADMIN_CP_QP_NOMINATION_TOOLTIP =
  'Click here to review the CP/QP Nominations';
export const ADMIN_REPORTING_WORKFLOW_TOOLTIP = `Click here to review the ${REPORTING_WORKFLOWS}`;
export const PROGRESS_TRACKER_TOOLTIP =
  'Click here to view Progress of Data Entry, Consent and CP/QP Nomination Workflows per Region';
export const CP_QP_NOMINATION_TOOLTIP =
  'Click here to review CP/QP Nominations assigned to you';
export const REPORTING_WORKFLOW_TOOLTIP = `Click here to review ${REPORTING_WORKFLOWS} assigned to you`;
export const REPORTING_YEAR = 'reporting-year';
export const NOMINATION_REPORTING_YEAR = 'nomination-reporting-year';
export const REPORTING_WORKFLOW_YEAR = 'workflow-reporting-year';
export const BACK_TO_REPORTING_WORKFLOW = `Back to ${REPORTING_WORKFLOWS}`;
